import script from "./HrListExpansion.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListExpansion.vue?vue&type=script&setup=true&lang=js"

import "./HrListExpansion.vue?vue&type=style&index=0&id=7f51b976&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f51b976"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QExpansionItem});
